/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Gender eligibility gate. Distinct from the buyer's actual gender (`Gender` enum) — `anyone` means no restriction. Null when the underlying value is missing or does not match a known enum member.
 */
export type LicenseGenderRestriction =
  (typeof LicenseGenderRestriction)[keyof typeof LicenseGenderRestriction];

export const LicenseGenderRestriction = {
  male: "male",
  female: "female",
  anyone: "anyone",
} as const;
